import Notify from 'quasar/src/plugins/notify/Notify.js';;

export function notifyError(group, message, color, icon) { // multi or single toastr, error message, toastr color, toastr icon
  if (!message) return;
  Notify.create({
    group: group,
    color: color,
    message,
    position: "bottom-right",
    icon: icon,
    html: true,
    timeout: 3000,
    actions: [
      {
        icon: 'close',
        color: 'white',
        round: true,
        dense: true,
      }
    ],
  });
}
